module.exports = __webpack_public_path__ + "static/jackie_day-f1b15e43017584819789e7a7caf31c75.jpg";